import React from "react";
import logo from "assets/logo/logo.png";
import { FaPhoneAlt, FaHeadset, FaEnvelope } from "react-icons/fa";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <div>
      <footer className="footer  py-14 px-10 bg-gray-800 bg-gray-900 text-base-content">
        <aside>
          <img loading="lazy" className="w-36 md:w-44" src={logo} alt="" />
        </aside>
        <nav>
          <header className="font-bold text-xl mb-3 text-white">
            Contactez-nous
          </header>
          <div className="flex flex-col space-y-3 text-base text-white">
            <p className="flex items-center gap-1">
              <FaHeadset />
              Steve Bonneau, Président
            </p>
            <p className="flex items-center gap-1">
              <FaPhoneAlt />
              514-222-3597
            </p>
            <p className="flex items-center gap-1">
              <FaEnvelope />
              info.fqst@gmail.com
            </p>
          </div>
        </nav>
      </footer>
      <div className="footer-center p-6 bg-gray-800 bg-gray-900 text-slate-300 border-t border-slate-500 text-sm">
        <p>Copyright © {year} - All right reserved</p>
      </div>
    </div>
  );
};

export default Footer;
